/**
 * MY — Allotment of Shares Cash (M32200) Register Detail 매핑.
 *
 * ⚠️ TASK_DATA.formData 실제 구조 (PreSetAllotmentSharesPanel.handleCreateTask):
 *   {
 *     entity, entityName, entityRegNo, transactionDate,
 *     shareholders: [{ shareholder, shareholderName, currencies:[{ currency, shareClasses:[{ classOfSharesName, numberOfShares, issuedShareCapital, ... }] }] }],
 *     presetForm: { companyName, sharePrice, allottees:[{name,shares,shareType,address,...}], ... }
 *   }
 *   → B32005 와 동일한 shareholders 포맷. repeat 는 shareholders 기준.
 */
import { registerRegisterDetail } from '@/features/startTask/preset_task/shared/preset/register/registerDetailRegistry';

registerRegisterDetail('M32200', {
  title: 'Allotment of Shares Details',
  // 저장된 shareholders 배열(B32005 포맷)을 행 단위로 미리보기.
  repeatArrayPath: 'shareholders',
  fields: [
    // 회사 (모든 행에 동일 표시 — 비반복 키)
    { label: 'Company Name', key: ['entityName', 'companyName', 'company_name'] },
    { label: 'Registration No.', key: ['entityRegNo', 'companyRegistrationNo'] },
    { label: 'Share Price (RM)', key: ['presetForm.sharePrice', 'sharePrice', 'share_price'] },
    // Allottee(= shareholder) 행별
    { label: 'Allottee', key: ['shareholders.0.shareholderName'] },
    { label: 'Class', key: ['shareholders.0.currencies.0.shareClasses.0.classOfSharesName'] },
    { label: 'Shares', key: ['shareholders.0.currencies.0.shareClasses.0.numberOfShares'] },
    { label: 'Amount (RM)', key: ['shareholders.0.currencies.0.shareClasses.0.issuedShareCapital'] },
  ],
});
